import React from "react";
import { Controller } from "react-hook-form";

const Checkbox = ({ title, control, name, onChange, className, checked, error }) => {
  const isControlled = typeof onChange === "function" && checked !== undefined;

  const render = (isChecked, handleChange) => (
    <>
      <input
        type="checkbox"
        checked={!!isChecked}
        onChange={handleChange}
      />
      <p className={`${isChecked ? "font-medium" : ""}`}>{title}</p>
      <span className="checkmark"></span>
    </>
  );

  return (
    <>
      <label className={`checkbox-container ${className || ""}`}>
        {isControlled ? (
          render(checked, onChange)
        ) : (
          <Controller
            name={name}
            control={control}
            defaultValue={false}
            render={({ field }) =>
              render(!!field.value, (e) => {
                field.onChange(e.target.checked);
                onChange && onChange(e);
              })
            }
          />
        )}
      </label>
      {error && <p className="error-message">{error}</p>}
    </>
  );
};

export { Checkbox };
